import React, {Component} from 'react';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import axios from "axios";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from "@material-ui/core/InputAdornment";
import AirplanemodeInactiveIcon from '@material-ui/icons/AirplanemodeInactive';
import CropSquare from '@material-ui/icons/CropSquare';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import FormHelperText from "@material-ui/core/FormHelperText";
import Sidebar from "../SideBar";
import {gsd, computeScanningDensity} from "../../utils/utils";
import {DialogTitle} from "@material-ui/core";
import CollapsibleScatteredRegionsVisitationAdvancedOptions
    from "./CollapsibleScatteredRegionsVisitationAdvancedOptions";



class CalculateScatteredRegionsVisitationPathsForm extends Component {

    render() {
        const {
            project,
            onProjectChange,
            onProjectCheckboxChange,
            darpLoading,
            executeScatteredRegionsLoading,
            onResetRegionOfInterest,
            onExecuteScatteredRegionsCalculatePaths,
            onCancelDarpClick,
            onAddPolygonClick,
            dronesConfig
        } = this.props;

        let uniqueDroneTypes = (droneConfig) => {
            let unique_values = droneConfig
                .map((drone) => drone.type)
                .filter(
                    (value, index, current_value) => current_value.indexOf(value) === index
                );
            return unique_values;
        };


        return (
            <div>

                <Paper style={{marginTop: '10px',
                    marginBottom: '10px'}}>
                    <TextField style={{textAlign: "left"}}
                               id="project-name"
                               label="Project Name"
                               value={project.name}
                               onChange={(evt) => {
                                   onProjectChange('name', evt)
                               }}
                               margin="normal"
                    />
                </Paper>

                <Paper style={{

                    marginTop: '10px',
                    marginBottom: '10px'
                }}>
                    <span>Operational Area</span>
                    <div style={{display: 'flex',
                        justifyContent: 'space-between'}}>
                        <Button variant="outlined" style={{margin: '5px'}} onClick={onAddPolygonClick} >
                            <CropSquare/>
                            Add Polygon
                        </Button>
                        <Button variant="outlined" style={{margin: '5px', whiteSpace: 'noWrap'}}
                                onClick={onResetRegionOfInterest(project.type)}>
                            <SettingsBackupRestoreIcon/>Reset ROI</Button>
                    </div>
                    <div style={{padding: '5px'}}>
                        <div>Area: {parseInt(project.scatteredRegionsOfInterestArea).toLocaleString('gr')} m&#178;</div>
                    </div>

                </Paper>

                <Paper style={{marginTop: '10px'}}>

                    <TextField style={{width: '50px'}}
                               id="standard-number"
                               label="Drones"
                               value={project.numberOfDrones}
                               onChange={(evt) => {
                                   if (evt.target.value < 1) {
                                       evt.target.value = "1";
                                   }
                                   onProjectChange('numberOfDrones', evt)
                               }}
                               type="number"
                               margin="normal"
                    />

                    <div style={{padding: '5px'}}>
                        <FormControl style={{width: '240px'}}>
                            <InputLabel htmlFor="type-of-waypointMission">Drone Type</InputLabel>
                            <Select
                                value={project.droneType}
                                onChange={(evt) => onProjectChange('droneType', evt)}
                                inputProps={{
                                    name: 'droneTypes',
                                    id: 'droneTypes',
                                }}>
                                {dronesConfig && dronesConfig.length > 0 ?
                                    uniqueDroneTypes(dronesConfig).map(droneType =>
                                        <MenuItem key={droneType} value={droneType}>
                                            <ListItemText primary={droneType.replace(/_/g, " ")}/>
                                        </MenuItem>
                                    ) : null}
                            </Select>
                        </FormControl>
                    </div>
                    <div style={{padding: '5px'}}>
                        <div>hFOV: {dronesConfig.filter(conf => {
                            return conf.type === project.droneType
                        })[0].hfov}
                        </div>
                        <div>vFOV: {dronesConfig.filter(conf => {
                            return conf.type === project.droneType
                        })[0].vfov}
                        </div>

                    </div>
                    <Paper style={{marginTop: '10px'}}>
                        <CollapsibleScatteredRegionsVisitationAdvancedOptions
                            project={project}
                            onProjectChange={onProjectChange}
                            onProjectCheckboxChange={onProjectCheckboxChange}/>

                        <div style={{position: 'relative', padding: '5px'}}>
                            <Button style={executeScatteredRegionsLoading ? {width: '100px'} : {width: '220px'}} variant="outlined"
                                    disabled={executeScatteredRegionsLoading} onClick={onExecuteScatteredRegionsCalculatePaths}>{
                                executeScatteredRegionsLoading ? 'Loading...' : 'Calculate Paths'}</Button>
                            {executeScatteredRegionsLoading && <CircularProgress size={24} style={{
                                // color: 'green[500]',
                                position: 'absolute',
                                top: '50%',
                                left: '25%',
                                marginTop: -12,
                                // marginLeft: -12,
                            }}/>}
                            {/*{executeScatteredRegionsLoading ? <Button style={{width: '100px'}} variant="outlined"*/}
                            {/*                       onClick={onCancelDarpClick}>Cancel</Button> : null}*/}
                        </div>
                    </Paper>
                </Paper>
            </div>
        )

    }
}

export default CalculateScatteredRegionsVisitationPathsForm;
